export const messagingRoutes = {
  inbox: 'messaging/inbox'
};
